export enum StatusType {
	SUCCESS = 'Success',
	DANGER = 'Danger',
	WARNING = 'Warning',
	INFO = 'Info',
}
